<sb-card>
  <div card-header>
    <b>{{'lang.deviceDetails.logHeadline' | translate}}</b>
  </div>
  <div card-header-more>
    <div class="d-lg-flex align-items-center d-none">
      <sb-comp-dropdown-select class="mr-1" (msOptionsChange)="msRequest($event)"
                               (selectedDataEmitter)="msUpdate($event)" [dropDownDatatype]="'DEVICE_LOG_DATATYPES'"
                               [inputData]="datatypes" [msOptions]="msDatatypeOptions" [selectedInputData]="filteredDatatypes"
                               [showColumnIcon]="true" [showSubmit]="true">
      </sb-comp-dropdown-select>
      <sb-local-date-time-input (modelChange)="handleDateChange($event)"></sb-local-date-time-input>
      <button class="btn btn-primary ml-2" (click)="export()">
        <sb-icon icon="download"></sb-icon>
        {{'lang.globals.export'|translate}}
      </button>
    </div>
  </div>
  <div card-body>
    <sb-device-log *ngIf="deviceId" [deviceId]="deviceId" [date]="date"
                   [logdatatypes]="filteredDatatypes"></sb-device-log>
  </div>
</sb-card>
